import { useState } from 'react'
import { Clock, Globe2 } from 'lucide-react'
import { CompanyCountryEditor } from './CompanyCountry'
import { CompanyTimezoneEditor } from './CompanyTimezone'
import { timezoneForCountry, countryForTimezone } from '../lib/country-timezone'

/**
 * The company's country and timezone, side by side. Company-wide settings —
 * each saves on its own through `PATCH /admin/company` and never with the
 * person's own preferences. Two-way suggestion: picking a country pre-fills a
 * matching timezone draft and vice versa; nothing saves until the matching
 * Save button is pressed. The cross-updates go through these drafts, not each
 * editor's onChange, so there's no feedback loop.
 */
export function CompanyRegionSettings() {
  const [suggestedTimezone, setSuggestedTimezone] = useState(null)
  const [suggestedCountry, setSuggestedCountry] = useState(null)
  return (
    <div className="mt-1 grid grid-cols-1 xl:grid-cols-2 gap-x-10">
      <div className="pt-3">
        <h3 className="m-0 flex items-center gap-2 text-sm font-medium text-[color:var(--color-ink-strong)]">
          <Globe2 size={15} aria-hidden="true" className="text-[color:var(--color-accent-dim)]" />
          Company country
        </h3>
        <p className="mt-1 mb-3 text-sm text-[color:var(--color-ink-muted)]">
          Chosen when the company was created. Picking a country fills in a matching company
          timezone for you to review and save. It doesn’t change your billing currency or
          anyone’s contact number.
        </p>
        <CompanyCountryEditor
          onCountryChange={(c) => setSuggestedTimezone(timezoneForCountry(c))}
          suggestedCountry={suggestedCountry}
        />
      </div>
      <div className="pt-3">
        <h3 className="m-0 flex items-center gap-2 text-sm font-medium text-[color:var(--color-ink-strong)]">
          <Clock size={15} aria-hidden="true" className="text-[color:var(--color-accent-dim)]" />
          Company timezone
        </h3>
        <p className="mt-1 mb-3 text-sm text-[color:var(--color-ink-muted)]">
          Report reminders go out at this local time. Calendar days — due dates, “today” and
          daily reports — follow it for everyone, and times show in it for members who
          haven’t chosen their own timezone. Picking a timezone also fills in a matching
          company country.
        </p>
        <CompanyTimezoneEditor
          suggestedTimezone={suggestedTimezone}
          onTimezoneChange={(tz) => setSuggestedCountry(countryForTimezone(tz))}
        />
      </div>
    </div>
  )
}
